import { RequestInterface } from 'application/connectors/cms/_api';
import { getSiteFromCDA } from 'application/connectors/cms/siteConnector';

export const getSite = async ({ pageContext }: RequestInterface): Promise<Models.Site> => {
	return await getSiteFromCDA(pageContext);
};
